import "./TextWithIcon.scss";
import { Font } from "../../Fonts/Font";
import PropTypes from "prop-types";
import { ICONPATH } from "../../../Constant";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect } from "react";

export const Type = {
  RIGHT: "right",
  LEFT: "left",
};

const TextWithIcon = ({
  icon,
  label,
  type,
  color,
  size,
  hasNoIcon,
  link,
  clickable,
  onClick,
  weight,
  cartItems,
  hasBadge,
  onclick,
  ...props
}) => {
  const count = cartItems?.cart_items?.length
    ? cartItems?.cart_items?.length
    : 0;
  useEffect(() => {});

  if (Type.RIGHT === type) {
    return (
      <div className="es-custom-text-with-icon">
        {hasBadge ? (
          <Link to={link}>
            <div style={{ position: "relative", cursor: "pointer" }}>
              <span className="badge">{count}</span>
              {!hasNoIcon && <img src={icon} alt={label} />}
            </div>
          </Link>
        ) : (
          !hasNoIcon && <img src={icon} alt={label} />
        )}
        {link ? (
          <Link to={link} onClick={onClick}>
            <Font
              onClick={onclick}
              label={label}
              color={color}
              size={size}
              weight={weight}
              clickable={clickable}
              link={link}
            />
          </Link>
        ) : (
          <Font
            onClick={onclick}
            label={label}
            color={color}
            size={size}
            weight={weight}
            clickable={clickable}
            link={link}
          />
        )}
      </div>
    );
  } else {
    return (
      <Link to={link} onClick={onClick}>
        <div className="es-custom-text-with-icon">
          <Font
            label={label}
            color={color}
            size={size}
            weight={weight}
            clickable={clickable}
            link={link}
          />
          {!hasNoIcon && <img src={icon} alt={label} />}
        </div>
      </Link>
    );
  }
};

TextWithIcon.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  weight: PropTypes.string,
  type: PropTypes.oneOf(Type.LEFT, Type.RIGHT),
};

TextWithIcon.defaultProps = {
  icon: ICONPATH.userIcon,
  label: "Profile",
  color: "#292929",
  size: 20,
  weight: 400,
  link: "#",
};

function mapStateToProps(state) {
  const { cartItems } = state;
  return {
    cartItems: cartItems?.cartItems,
  };
}

const count = connect(mapStateToProps)(TextWithIcon);

export { count as TextWithIcon };
